import { AfterContentInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { Configuration } from 'src/app/domain/configuration';
import { LimitCategory } from 'src/app/domain/limit-category';
import { LimitCategoryService } from 'src/app/services/limit-category.service';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { NgxColorsModule } from 'ngx-colors';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { GetColorName } from "hex-color-to-color-name";
import { MatTooltip } from "@angular/material/tooltip";

@Component({
    selector: 'app-limit-category-box',
    templateUrl: './limit-category-box.component.html',
    styleUrl: './limit-category-box.component.scss',
    standalone: true,
    imports: [MatDialogModule, MatSlideToggleModule, ReactiveFormsModule, FormsModule, MatFormFieldModule, MatInputModule, NgxColorsModule, MatButtonModule, PreventDoubleClickDirective, MatTooltip]
})
export class LimitCategoryBoxComponent implements OnInit, AfterContentInit {

    Configuration: Configuration = new Configuration()
    Model: LimitCategory = new LimitCategory();
    IsCreation: boolean = true;

    constructor(
        public dialogRef: MatDialogRef<LimitCategoryBoxComponent>,
        private limitCategoryService: LimitCategoryService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data.category) {
            this.Model = Object.assign({}, data.category);
            this.IsCreation = false;
        }
        this.Configuration = Object.assign({}, data.configuration);
    }

    ngOnInit(): void {
    }

    ngAfterContentInit(): void {

    }

    GetColorName(hex: string) {
        return GetColorName(hex);
    }

    CanSave() {
        return true;
    }

    deleteCategory() {
        this.limitCategoryService.delete(this.Model.Code).subscribe(x => {
            if (x) {
                this.dialogRef.close(null);
            }
        })
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (this.CanSave())
            this.dialogRef.close(this.Model);

    }
}
